export { default } from './PictoTextRow';
export type { IPrismicPictoTextRowItem } from './types';
